import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Transaktionen", -1)
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_TransactionContainer = _resolveComponent("TransactionContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", null, [
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.unpaid,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.unpaid) = $event)),
        onChange: _ctx.onChangePaid,
        label: "Noch nicht verrechnet",
        size: "large"
      }, null, 8, ["modelValue", "onChange"])
    ]),
    (!_ctx.unpaid)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.value1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value1) = $event)),
            type: "daterange",
            "unlink-panels": "",
            "range-separator": "bis",
            "start-placeholder": "Start Datum",
            "end-placeholder": "End Datum",
            shortcuts: _ctx.shortcuts,
            onChange: _ctx.onTimeChanged
          }, null, 8, ["modelValue", "shortcuts", "onChange"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_TransactionContainer, { transactions: _ctx.transactions }, null, 8, ["transactions"])
  ]))
}